import api from '@/api';
import session from '@/storage/session';
import store from '@/bootstrap/vuex';

export default {
    namespaced: true,
    actions: {
        search(filters) {
            return api.get('/timezones', filters);
        },
        fetch(timezoneId) {
            return api.get(`/timezones/${timezoneId}`, null);
        },
        fetchCached() {
            if (session.missing('timezones')) {
                return api.fetch('/timezones', {
                    'cache-response': true,
                    'cache-key': 'timezones',
                });
            } else {
                const response = session.fetch('timezones');
                return Promise.resolve(response);
            }
        },
        fetchLists() {
            api.batch([store.dispatch('subscribers/fetchCached', null, { root: true }), store.dispatch('users/fetchCached', null, { root: true })])
                .then((response) => {
                    return Promise.resolve(response);
                })
                .catch((error) => {
                    if (error.response) {
                        return Promise.reject(error.response);
                    }
                    return Promise.reject(null);
                });
        },
        save(timezone) {
            return api
                .post('/timezones', timezone)
                .then((response) => {
                    session.destroy('timezone');
                    return Promise.resolve(response);
                })
                .catch((error) => {
                    if (error.response) {
                        return Promise.reject(error.response);
                    }
                    return Promise.reject(null);
                });
        },
        update(timezoneId, timezone) {
            return api
                .put(`/timezones/${timezoneId}`, timezone)
                .then((response) => {
                    session.destroy('timezone');
                    return Promise.resolve(response);
                })
                .catch((error) => {
                    if (error.response) {
                        return Promise.reject(error.response);
                    }
                    return Promise.reject(null);
                });
        },
        archive(timezoneId) {
            return api.put(`/timezones/archive/${timezoneId}`, null);
        },
        delete(timezoneId) {
            return api.delete(`/timezones/${timezoneId}`, null);
        },
    },
};
